import { signal } from '@preact/signals-react';
import { Funcionalidade, Rbac } from '@stt-console/util';

export const usuarioSignal = signal({
    email: '',
    nome: '',
    login: '',
    cpf: '',
    permissoesRBAC: [],
    perfisRBAC: [],
    submodulos: [],
    isAuthorized: false,
    rbac: new Rbac([]),
    autenticado: false,
});

export const alterarUsuario = ({ email, nome, login, cpf, permissoesRBAC = [], perfisRBAC = [] }) => {
    const rbac = new Rbac(perfisRBAC);

    const isAuthorized = rbac.montarAcesso(Funcionalidade.MODULO).temPermissao;

    usuarioSignal.value = {
        ...usuarioSignal.value,
        email,
        nome,
        login,
        cpf: cpf || '',
        permissoesRBAC,
        perfisRBAC,
        isAuthorized,
        rbac,
        autenticado: true,
    };
};

export const autenticar = () => {
    usuarioSignal.value = {
        ...usuarioSignal.value,
        autenticado: true,
    };
};